import PropTypes from 'prop-types'

const LEGEND = PropTypes.shape({
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
  iconType: PropTypes.oneOf([
    'line',
    'plainline',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
  ]),
  iconSize: PropTypes.number,
  wrapperStyle: PropTypes.shape({}),
  extraProps: PropTypes.shape({}),
})

const COLORS_GRADIENTS = PropTypes.arrayOf(
  PropTypes.shape({
    to: PropTypes.string.isRequired,
    from: PropTypes.string.isRequired,
    text: PropTypes.string,
  })
)

export const PROPTYPES = {
  LEGEND,
  COLORS_GRADIENTS,
}
